// for sprintf
if (!String.prototype.repeat) {
    String.prototype.repeat = function (count) {
        'use strict';
        if (this == null) {
            throw new TypeError('can\'t convert ' + this + ' to object');
        }
        var str = '' + this;
        count = +count;
        if (count != count) {
            count = 0;
        }
        if (count < 0) {
            throw new RangeError('repeat count must be non-negative');
        }
        if (count == Infinity) {
            throw new RangeError('repeat count must be less than infinity');
        }
        count = Math.floor(count);
        if (str.length == 0 || count == 0) {
            return '';
        }
        // Ensuring count is a 31-bit integer allows us to heavily optimize the
        // main part. But anyway, most current (August 2014) browsers can't handle
        // strings 1 << 28 chars or longer, so:
        if (str.length * count >= 1 << 28) {
            throw new RangeError('repeat count must not overflow maximum string size');
        }
        var rpt = '';
        for (; ;) {
            if ((count & 1) == 1) {
                rpt += str;
            }
            count >>>= 1;
            if (count == 0) {
                break;
            }
            str += str;
        }
        // Could we try:
        // return Array(count + 1).join(this);
        return rpt;
    }
}

let sprintf = require('sprintf-js').sprintf

function noop() { }

function notImplemented() {
    throw new Error('Not implemented')
}

function notSupported() {
    throw new Error('Not supported')
}

function checkString(s) {
    let type = typeof s;
    if (type === 'string') {
        return s
    } else if (type === 'number') {
        return s.tostring(s)
    } else {
        throw new TypeError()
    }
}

function assertFloat(n) {
    let result = parseFloat(n)
    if (isNaN(result)) {
        throw new Error('Invalid number: ' + n)
    }
    return result
}

let lua = {
    assert(v, msg = 'Assertion failed!') {
        if (!v) lua.error(msg)
    },

    collectgarbage: noop,

    error(val) {
        if (typeof (val) === 'string') {
            throw new Error(val)
        } else {
            throw val
        }
    },

    ipairs: notSupported,

    load: notImplemented,
    loadfile: notSupported,
    loadString: notImplemented,

    pcall(func, ...args) {
        try {
            let ret = [true].concat(func.apply(null, args))
            // need test
            return ret
        } catch (e) {
            console.error(e)
            return [false, e]
        }
    },

    next: notSupported,

    pairs: notSupported,

    print: console.log,

    rawequal: notSupported,
    rawget: notSupported,
    rawset: notSupported,
    setfenv: notSupported,
    select: notImplemented,

    type(v) {
        if (v === null || v === undefined) {
            return 'nil'
        }
        var t = typeof (v)
        switch (t) {
            case 'number':
            case 'boolean':
            case 'string':
            case 'function':
                return t
            case 'object':
                if (v.__isLuaTable) {
                    return 'table'
                }
            default:
                throw new Error('Unepected value of type ' + t)
        }
    },

    tonumber(e, base) {
        if (typeof e == 'number') {
            return e
        }
        if (base === 10 || base == null) {
            return parseFloat(e)
        } else {
            return parseInt(e, base)
        }
    },

    tostring(v) {
        if (v === null || v === undefined) {
            return 'nil'
        } else {
            return v.toString()
        }
    },

    dofile: notSupported,
    getfenv: notSupported,

    getmetatable: notSupported,
    setmetatable: notSupported,

    // xpcall: function (f, msgh) {
    //     let args = Array.prototype.slice.call(arguments, 2)
    //     try {
    //         return f.apply(null, args)
    //         // return lua.$call(f, args)
    //     } catch (e) {
    //         return msgh.call(null, e)
    //         // return lua.$call(msgh, [e])
    //     }
    // },

    xpcall: notImplemented,

    math: {
        _randomSeed: null,

        huge: Infinity,
        rad(deg) { return deg * Math.PI / 180 },
        deg(rad) { return rad * 180 / Math.PI },

        ldexp(m, e) { return m * Math.pow(2, e) },
        frexp: notSupported,

        fmod(x, y) { return x % y },
        // modf(x, y) {
        //     var frac = x % 1
        //     return [x - frac, frac]
        // },
        modf: notSupported,

        randomseed(seed) { this._randomSeed = seed },
        random(m, n) {
            let r
            if (this._randomSeed) {
                this._randomSeed = (this._randomSeed * 9301 + 49297) % 233280
                r = this._randomSeed / 233280
            } else {
                r = Math.random()
            }
            if (m || m === 0) {
                if (!n && n !== 0) {
                    return Math.floor(r * m) + 1
                }
                return Math.floor(r * (n - m + 1)) + m
            }
            return r
        }
    },

    string: {
        upper(s) { return checkString(s).toUpperCase() },
        lower(s) { return checkString(s).toLowerCase() },
        len(s) { return checkString(s).length },

        char() {
            return String.fromCharCode.apply(null, arguments)
        },

        byte(s, i = 1, j = i) {
            if (i < 0) {
                i = s.length + i
            } else {
                i--
            }
            if (j < 0) {
                j = s.length + j + 1
            }
            var ret = []
            for (; i < j; ++i) {
                var c = s.charCodeAt(i)
                if (c) {
                    ret.push(c)
                }
            }
            return ret
        },

        sub(s, i, j) {
            i = i < 0 ? (i + s.length + 1) : (i >= 0 ? i : 0)
            if (j == null) {
                j = -1
            }
            j = j < 0 ? (j + s.length + 1) : (j >= 0 ? j : 0)
            if (i < 1) {
                i = 1
            }
            if (j > s.length) {
                j = s.length
            }
            if (i <= j) {
                return s.substr(i - 1, j - i + 1)
            } else {
                return ''
            }
        },


        rep(s, n) { return checkString(s).repeat(n) },
        reverse(s) { return checkString(s).split('').reverse().join('') },
        format() { return sprintf.apply(null, arguments) },
        dump: notSupported,
        find: notSupported,
        match: notSupported,
        gmatch: notSupported,
        gsub: notSupported,

    },

    os: {
        clock: function () {
            let start = Date.now()
            return function () {
                return (Date.now() - start) / 1000
            }
        }(),

        time(date) {
            if (!date) {
                return Date.now() / 1000
            }else {
                let d = date.year + "/" + date.month + "/" + date.day + " " + date.hour + ":" + date.min + ":" + date.sec
                return new Date(d).getTime() / 1000
            }
        },
        difftime(t2, t1) { return t2 - t1 },

        date: notSupported,
        remove: notSupported,
        rename: notSupported,
        tempname: notSupported,
        setlocale: notSupported,
        exit: notSupported,
        execute: notSupported,
        date: notSupported
    },

    bit: {
        tobit(x) { return x << 0 },

        tohex(x, n) {
            if (n > 0) {
                var str = x.toString(16).substr(-n);
                while (str.length < n) {
                    str = '0' + str
                }
                return str
            } else if (n < 0) {
                var str = x.toString(16).substr(n).toUpperCase()
                while (str.length < -n) {
                    str = '0' + str
                }
                return str
            } else {
                return x.toString(16)
            }
        },

        bnot(x) { return ~x },

        bor(x) {
            x = assertFloat(x)
            for (var i = 1; i < arguments.length; i++) {
                x |= arguments[i];
            }
            return x
        },

        band(x) {
            x = assertFloat(x);
            for (var i = 1; i < arguments.length; i++) {
                x &= arguments[i];
            }
            return x
        },

        bxo(x) {
            x = assertFloat(x)
            for (var i = 1; i < arguments.length; i++) {
                x ^= arguments[i]
            }
            return x
        },

        lshift(x, n) {
            return x << n
        },

        rshift(x, n) {
            return x >>> n
        },

        arshift(x, n) {
            return x >> n
        },

        rol(x, n) {
            n &= 0xf
            return (x << n) | (x >>> -n)
        },

        ror(x, n) {
            n &= 0xf
            return (x >>> n) | (x << -n)
        },

        bswap(x) {
            // from Bit Twiddling hacks <http://graphics.stanford.edu/~seander/bithacks.html>
            x = ((x >> 1) & 0x55555555) | ((x & 0x55555555) << 1)
            x = ((x >> 2) & 0x33333333) | ((x & 0x33333333) << 2)
            x = ((x >> 4) & 0x0F0F0F0F) | ((x & 0x0F0F0F0F) << 4)
            x = ((x >> 8) & 0x00FF00FF) | ((x & 0x00FF00FF) << 8)
            x = (x >> 16) | (x << 16)
            return x
        }

    },

    io: {},
    coroutine: {},
    debug: {
        getmetatable(obj) {
            return lua.getmetatable(obj)
        }
    },

}


    ;['open', 'write', 'input', 'output', 'close', 'tempname', 'type', 'flush', 'lines'].forEach(
        key => lua.io[key] = notSupported
    )

    ;['resume', 'running', 'status', 'wrap', 'yield'].forEach(
        key => lua.coroutine[key] = notSupported
    )

    ;['traceback', 'getfenv', 'gethook', 'getinfo', 'getlocal', 'getregistry', 'getupvalue', 'setfenv', 'sethook', 'setlocal', 'setupvalue', 'debug'].forEach(
        key => lua.debug[key] = notSupported
    )


const tableZeroDescriptors = {
    configurable: true,
    enumerable: false,
    // 使用 # 会使 !table[0] 判断失败
    get: function () { return null },
    set: function (val) {
        // 有零值重置修饰符
        Object.defineProperty(this, '0', {
            configurable: true,
            enumerable: true,
            writable: true,
            value: val
        })
    }
}

const tableTagDescriptors = {
    configurable: false,
    enumerable: false,
    writable: false,
    value: true
}

function pushFieldsToLuaTable(t, fields) {
    for (var i = 0; i < fields.length; i++) {
        var v = fields[i]
        if (Array.isArray(v) && !v.__isLuaTable) {
            if (v[0] === 0) {
                t.push(v[1])
            } else if (v[0] === 1) {
                t[v[1]] = v[2]
            } else {
                for (var j = 0; j < v[1].length; j++) {
                    t.push(v[1][j])
                }
            }
        } else {
            // 字面量
            t.push(v)
        }
    }
}

lua.table = function LuaTable() {
    let arr = []
    Object.defineProperty(arr, '0', tableZeroDescriptors)
    Object.defineProperty(arr, '__isLuaTable', tableTagDescriptors)
    pushFieldsToLuaTable.call(null, arr, arguments)
    return arr
}

lua.sTable = function SimpleLuaTable() {
    let arr = [null]
    arr.__isLuaTable = true
    pushFieldsToLuaTable.call(null, arr, arguments)
    return arr
}

let tableStatic = {

    unpack(t) { return t.slice(1) },

    concat(t, sep = '', i, j) {
        let list
        if (i) {
            if (j) {
                list = t.slice(i, j + 1)
            } else {
                list = t.slice(i)
            }
        } else {
            list = t.slice(1)
        }
        return list.join(sep)
    },

    getn(t) {
        if (t.__isLuaTable) {
            return t.length - 1
        } else {
            throw new TypeError('LuaTable expected')
        }
    },

    insert(t, pos, value) {
        if (value) {
            if (pos < 1 || pos > t.length + 1) {
                throw new Error('bad argument #2 to \'insert\' (position out of bounds)')
            }
            t.splice(pos, 0, value)
        } else {
            t.push(pos)
        }
    },

    maxn: notImplemented,

    remove(t, pos) {
        if (pos) {
            if (pos < 1) return null
            return t.splice(pos, 1)[0]
        } else {
            if (t.length > 1) {
                return t.pop()
            } else {
                return null
            }
        }
    },

    sort(t, comp) {
        let zero = t.shift()
        if (comp) {
            // 解决不同浏览器sort排序结果可能不同的bug
            t.sort((a, b) => {
                if (comp(a, b)) {
                    return -1
                } else if (comp(b, a)) {
                    return 1
                } else {
                    return 0
                }
            })

            // 解决不同浏览器sort排序结果可能不同的bug
            // let length = t.length;
            // for (var i = 0; i <length - 1; i++) {
            //     for (var j = 0; j < length - i - 1; j++) {
            //         let compare = comp(t[j], t[j + 1]);
            //         if (!compare) {
            //             let tmp = t[j];
            //             t[j] =  t[j + 1];
            //             t[j + 1] = tmp;
            //         }
            //     }
            // }

        } else {
            t.sort((a, b) => {
                return a - b
            })
        }
        t.unshift(zero)
        Object.defineProperty(t, '0', tableZeroDescriptors)
    },

    // 解决不同浏览器sort排序结果可能不同的bug
    nonNativeSort(t, comp) {
                let zero = t.shift()
        if (comp) {
            let length = t.length;
            for (var i = 0; i <length - 1; i++) {
                for (var j = 0; j < length - i - 1; j++) {
                    let compare = comp(t[j], t[j + 1]);
                    if (!compare) {
                        let tmp = t[j];
                        t[j] =  t[j + 1];
                        t[j + 1] = tmp;
                    }
                }
            }

        } else {
            t.sort((a, b) => {
                return a - b
            })
        }
        t.unshift(zero)
        Object.defineProperty(t, '0', tableZeroDescriptors)
    },

    serialize2(t) {
        function _serialize2(t, obj) {
            if(!t){
                return;
            }
            for(var i = 1; i < t.length; i++){
                var v = t[i];
                var item = {};
                if (v instanceof Object) {
                    for(var attr in v){
                        if(Array.isArray(v[attr])){
                            item[attr] = {};
                            _serialize2(v[attr], item[attr]);
                        }
                        else{
                            item[attr] = v[attr];
                        }
                    }
                    obj[i] = item;
                } else if(Array.isArray(v)){
                    _serialize2(v, item);
                } else {
                    obj[i] = v;
                }
            }
        }
        var obj = {};
        _serialize2(t, obj);
        return JSON.stringify(obj);
    }

}

for (let key in tableStatic) {
    lua.table[key] = tableStatic[key]
}

lua.table.constructor = lua.table
lua.unpack = lua.table.unpack

module.exports = lua
